// extracted by mini-css-extract-plugin
export default {"container":"MyAccount_container__0e4YG","content":"MyAccount_content__91uVJ"};